import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, id, include, options, isPreview) => appendPaginationQueryParamsToUrl(`${host}${isPreview ? '/preview' : ''}/contentCreators/${id}/contentCreations?${include}`, {...options, alreadyHasQueryParams: true});

export default host => (id, include = "include=video.thumbnail;image;audio;binary;embededContent", options = {}, isPreview =false) =>
  get(url(host, id, include, options, isPreview))
    .then(response => response.json())
